<section class="bg-(--color-secondary) min-h-screen py-4">
  <!-- header -->
  <div class="why-header text-center">
    <span class="bg-(--color-main-20) text-(--color-main)">
      <svg class="w-5 h-5" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6 4l6 6-6 6"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      مميزاتنا
    </span>

    <div class="py-5">
      <h2>لماذا تختارنا؟</h2>
    </div>
  </div>

  <!-- cards -->
  <div class="max-w-6xl mx-auto px-6 mt-9 grid grid-cols-1 md:grid-cols-2 gap-8 mb-20">
    <!-- Card 1 -->
    <div class="why-card">
      <div class="icon-box">
        <i class="fa-solid fa-award text-(--color-secondary) text-3xl"></i>
      </div>
      <h3>الشفافية</h3>
      <p>
        كل عقد، كل تقرير، كل صورة وفيديو من الأرض — متاح لك في أي وقت. لا توجد بنود خفية ولا أرقام
        مُخفّاة.
      </p>
    </div>

    <!-- Card 2 -->
    <div class="why-card">
      <div class="icon-box">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.8"
          stroke="currentColor"
          class="w-8 h-8 text-(--color-secondary)"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 3l7 4v5c0 5-3.5 9-7 10-3.5-1-7-5-7-10V7l7-4z"
          />
        </svg>
      </div>

      <h3>الأمان</h3>
      <p>
        نطبّق أعلى معايير إدارة المخاطر قبل طرح أي مشروع. كل فرصة تمر بمراحل تدقيق صارمة من فرق
        متخصصة.
      </p>
    </div>

    <!-- Card 3 -->
    <div class="why-card">
      <div class="icon-box">
        <i class="fa-solid fa-seedling text-(--color-secondary) text-3xl"></i>
      </div>
      <h3>الاستدامة</h3>
      <p>
        نعمل من أجل عوائد طويلة الأمد، لا مكاسب آنية. ممارساتنا الزراعية تحترم الأرض وتحافظ على
        الموارد للأجيال القادمة.
      </p>
    </div>

    <!-- Card 4 -->
    <div class="why-card">
      <div class="icon-box">
        <i class="fa-solid fa-arrow-trend-up text-(--color-secondary) text-3xl"></i>
      </div>

      <h3>الاحترافية</h3>
      <p>
        فريقنا يضم أفضل المهندسين الزراعيين والمستشارين الماليين والقانونيين، يعملون بأعلى معايير
        الجودة والمهنية.
      </p>
    </div>

    <!-- Card 5 -->
    <div class="why-card">
      <div class="icon-box">
        <i class="fa-solid fa-seedling text-(--color-secondary) text-3xl"></i>
      </div>

      <h3>التمكين</h3>
      <p>
        نُعلّمك ولا نقرر بدلاً منك. نوفر لك الأدوات التحليلية والتعليمية لتكون متعاقداً واعياً
        قادراً على اتخاذ قراراتك بثقة.
      </p>
    </div>
  </div>
</section>
